import React from 'react';
import { ink } from '../../primitives.js';

const h = React.createElement;

/**
 * Progress bar (role=progressbar).
 *
 * @param {object} p
 * @param {number} [p.pct]
 * @param {string} [p.color]
 * @param {number} [p.h]
 * @param {React.CSSProperties} [p.style]
 */
export function Bar({ pct = 0, color = 'var(--lime)', h: hh = 8, style }) {
  const [ready, setReady] = React.useState(false);
  React.useEffect(() => { const id = requestAnimationFrame(() => setReady(true)); return () => cancelAnimationFrame(id); }, []);
  const p = ready ? Math.max(2, Math.min(100, pct)) : 2;
  return h('div', { role: 'progressbar', 'aria-valuenow': Math.round(pct), 'aria-valuemin': 0, 'aria-valuemax': 100, style: { height: hh, background: 'var(--track)', border: ink(1.5), borderRadius: hh, overflow: 'hidden', boxSizing: 'border-box', ...style } },
    h('div', { style: { width: p + '%', height: '100%', background: color, borderRight: p < 100 ? ink(1.5) : 'none', transition: 'width 520ms var(--ease-pop)' } }));
}
